<template>
    <div class="story-maker-sticker story-maker-sticker-post">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish">Terminé</p>
        <div class="sticker-post" :class="[typePost, files[idFile].info.aspectRatio > 0.5625 ? 'containX' : 'containY']">
           
           <video v-if="files[idFile].info.type2 == 'video'" muted playsinline loop autoplay preload="metadata" class="video" onloadedmetadata="this.muted = true">
                <source :src="files[idFile].url" type="video/mp4">
            </video>
            <img v-else class="selectDisable" draggable="false" :src="files[idFile].url">
            <p class="namePage">{{typePost !== 'reel' ? '@' : ''}} {{ $attrs.pageSelected ? $attrs.pageSelected.name : 'auteur' }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            idFile: Number | String,
            typePost: String,
            files:Object,
        },
    }
</script>
